import React, {
  useCallback, useEffect, useRef, useState,
} from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';

import FileIcon from '../../../../assets/file-icon.svg';
import EllipsisToolTip from '../EllipsisToolTip';

import styles from '../../../styles/views/components/AIChatbot/FilesList.module.scss';

const MAX_FILES_NUMBER_TO_SHOW_ON_WINDOW = 3;

const FilesList = ({ files }) => {
  const toolTipWrapperRef = useRef(null);
  const [isTooltipShown, setIsTooltipShown] = useState(false);

  const openTooltip = useCallback(() => setIsTooltipShown(true), []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isTooltipShown
          && toolTipWrapperRef
          && !toolTipWrapperRef.current.contains(event.target)
      ) {
        setIsTooltipShown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isTooltipShown]);

  const filesToShowOnWindow = files.length > MAX_FILES_NUMBER_TO_SHOW_ON_WINDOW
    ? files.slice(0, MAX_FILES_NUMBER_TO_SHOW_ON_WINDOW)
    : files;
  const filesToShowOnTooltip = files.slice(MAX_FILES_NUMBER_TO_SHOW_ON_WINDOW);

  return (!isEmpty(files) ? (
    <div className={styles.container}>
      <div className={styles.contentWrapper}>
        {filesToShowOnWindow.map((file) => (
          <div className={styles.fileWrapper} key={file._id}>
            <div className={styles.iconWrapper}>
              <FileIcon />
            </div>
            <div className={styles.fileNameWrapper}>
              <EllipsisToolTip tooltipText={file.originalname}>
                <span className={styles.fileName}>{file.originalname}</span>
              </EllipsisToolTip>
            </div>
          </div>
        ))}
        {files.length > MAX_FILES_NUMBER_TO_SHOW_ON_WINDOW && (
          <div className={styles.filesNumber} onClick={openTooltip}>
            <span>{`+${files.length - MAX_FILES_NUMBER_TO_SHOW_ON_WINDOW}`}</span>
          </div>
        )}
      </div>
      {isTooltipShown && (
        <div className={styles.tooltipWrapper} ref={toolTipWrapperRef}>
          <div className={styles.tooltipContent}>
            {filesToShowOnTooltip.map((file) => (
              <div className={styles.fileWrapper} key={file._id}>
                <div className={styles.iconWrapper}>
                  <FileIcon />
                </div>
                <div className={styles.fileNameWrapper}>
                  <EllipsisToolTip tooltipText={file.originalname}>
                    <span className={styles.fileName}>{file.originalname}</span>
                  </EllipsisToolTip>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  ) : null);
};

FilesList.propTypes = {
  files: PropTypes.array,
};

FilesList.defaultProps = {
  files: [],
};

export default FilesList;
